module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/candle@2x_89a989.png";